import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6321a175&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6321a175&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6321a175",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6321a175')) {
      api.createRecord('6321a175', component.options)
    } else {
      api.reload('6321a175', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6321a175&scoped=true", function () {
      api.rerender('6321a175', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P4_Page/Deprecated/index.vue"
export default component.exports